import { APIRoute } from '@/modules/utils'
import { PricePlan } from '@/data'
import { IRI } from 'emt-library'

export const Route = (planIri: IRI): APIRoute => ({
  method: 'GET',
  path: planIri,
})

export type Response = PricePlan
